// extracted by mini-css-extract-plugin
export default {"background":"Window_background__UNtG1","glas":"Window_glas__7IoCj"};